import React from 'react';
import ReactDOM from 'react-dom';
import angular from 'angular';
import { EndCallConfirmationPopup } from './EndCallConfirmationPopup';
import { withProviders } from '../../../core/components';
export default angular
    .module('doxy.call.end-call-confirmation-popup', [])
    .component('endCallConfirmationPopup', {
    // end-call-confirmation-popup
    bindings: {},
    template: `<div></div>`,
    controller: function ($element) {
        const reactContainer = $element[0];
        const render = () => {
            ReactDOM.render(React.createElement(withProviders(EndCallConfirmationPopup), {}), reactContainer);
        };
        this.$onInit = render;
        this.$onDestroy = () => ReactDOM.unmountComponentAtNode(reactContainer);
    },
}).name;
